module.exports = __webpack_public_path__ + "static/media/icons8-funnel.04ee450b.svg";